<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-card>
      <v-card-text>
        <v-select
          v-model="selectedSpec"
          label="Select"
          :items="judgeSettings?.data"
          item-value="id"
          item-title="name"
          multiple></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" @click="emit('judgeSpecialtyCancled')">Cancel</v-btn>
        <v-btn type="submit" color="primary">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script setup lang="ts">
import { IPaginationDTO, JudgeSpecialityDTO, PaginationDTO } from '@/dtos';
import { BranchYearJudgeDTO, IBranchYearJudgeDTO } from '@/dtos/branch.year.judge.dto';
import { useUpdateStatusStore } from '@/stores';
import { useAdminJudgeStore, useSettingsStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  judge?: BranchYearJudgeDTO;
}>();
const emit = defineEmits(['snack', 'judgeSpecialtySaved', 'judgeSpecialtyCancled']);

const settingsStore = useSettingsStore();
const statusStore = useUpdateStatusStore();
const judgeStore = useAdminJudgeStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const judge = ref<IBranchYearJudgeDTO>(new BranchYearJudgeDTO(props.judge));
const { data: judgeSettings } = settingsStore.getAllJudgeSpecialitiesSettings(pagination);

const selectedSpec = computed({
  get: () => judge.value.specialities.map((spec) => spec.id),
  set: (ids: []) => {
    judge.value.specialities = [];
    for (const id of ids) {
      judge.value.specialities.push(
        new JudgeSpecialityDTO(judgeSettings.value?.data.find((spec) => spec.id == id)),
      );
    }
  },
});

watch(
  () => props.judge,
  () => {
    judge.value = new BranchYearJudgeDTO(props.judge);
    console.log('judge', judge.value);
  },
);

const onSubmit = async () => {
  judgeStore.updateBranchYearJudge.mutateAsync(judge.value);
};

const key = computed(() => `branch-year-judge-update-${judge.value.id}`);
watch(
  () => statusStore.getStatus(key.value),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    emit('snack', 'Judge', value, statusStore.getError(key.value));
    emit('judgeSpecialtySaved');
  },
);
</script>
